import LoginForm from "pages/QRScan/components/LoginForm";

export default LoginForm;